import { render, staticRenderFns } from "./add-user.vue?vue&type=template&id=94bfe296&"
import script from "./add-user.vue?vue&type=script&lang=js&"
export * from "./add-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports